import { render, staticRenderFns } from "./CellHead.vue?vue&type=template&id=22b04b0b&scoped=true&"
import script from "./CellHead.vue?vue&type=script&lang=js&"
export * from "./CellHead.vue?vue&type=script&lang=js&"
import style0 from "./CellHead.vue?vue&type=style&index=0&id=22b04b0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b04b0b",
  null
  
)

export default component.exports